export default {
  defaultProps: {
    focusBorderColor: 'primary.400',
  },
}
